import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(user.role === 'admin' ? '/admin/dashboard' : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      {/* Left panel */}
      <div style={s.leftPanel}>
        <div style={s.leftContent}>
          <img src="/ishan-logo.webp" alt="Ishan Technologies" style={s.logoLeft} />
          <img src="/saksham_logo_white.png" alt="Saksham Cloud" style={s.logoSaksham} />
          <h1 style={s.heroTitle}>Billing Dashboard</h1>
        </div>
        <div style={s.leftFooter}>Powered by Ishan Technologies</div>
      </div>

      {/* Right panel - login form */}
      <div style={s.rightPanel}>
        <div style={s.formCard}>
          <div style={s.formHeader}>
            <img src="/ishan-logo.webp" alt="Ishan Technologies" style={s.logoForm} />
            <h2 style={s.formTitle}>Sign in</h2>
            <p style={s.formSubtitle}>Enter your credentials to access the dashboard</p>
          </div>

          {error && (
            <div style={s.errorBox}>
              <span>⚠</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={s.form}>
            <div style={s.field}>
              <label style={s.label}>Email address</label>
              <input
                type="email"
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                placeholder="you@ishantech.com"
                required
                style={s.input}
                onFocus={e => e.target.style.borderColor = '#2563eb'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            <div style={s.field}>
              <label style={s.label}>Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPass ? 'text' : 'password'}
                  value={form.password}
                  onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder="••••••••"
                  required
                  style={s.input}
                  onFocus={e => e.target.style.borderColor = '#2563eb'}
                  onBlur={e => e.target.style.borderColor = '#e2e8f0'}
                />
                <button type="button" onClick={() => setShowPass(!showPass)} style={s.eyeBtn}>
                  {showPass ? '🙈' : '👁'}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} style={{ ...s.submitBtn, opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Signing in...' : 'Sign in →'}
            </button>
          </form>

          <div style={s.demoBox}>
            <div style={s.demoTitle}>Demo Credentials</div>
            <div style={s.demoRow}>
              <span style={s.demoRole}>Admin</span>
              <span style={s.demoEmail}>admin@company.com</span>
              <span style={s.demoPass}>Admin@123</span>
            </div>
            <div style={s.demoRow}>
              <span style={{ ...s.demoRole, background: '#dcfce7', color: '#166534' }}>Client</span>
              <span style={s.demoEmail}>client@company.com</span>
              <span style={s.demoPass}>Client@123</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { display: 'flex', minHeight: '100vh', background: '#f8fafc' },
  leftPanel: {
    width: '45%', background: 'linear-gradient(145deg, #1e3a8a 0%, #1d4ed8 50%, #2563eb 100%)',
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
    padding: '48px 56px',
  },
  leftContent: { flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingTop: 40 },
  logoLeft: { height: 40, objectFit: 'contain', objectPosition: 'left', marginBottom: 20 },
  logoSaksham: { height: 34, objectFit: 'contain', objectPosition: 'left', marginBottom: 36, opacity: 0.92 },
  heroTitle: { color: '#fff', fontSize: 32, fontWeight: 700, lineHeight: 1.2, marginBottom: 16, letterSpacing: '-0.5px' },
  heroSub: { color: 'rgba(255,255,255,0.75)', fontSize: 16, lineHeight: 1.7, marginBottom: 40 },
  featureList: { display: 'flex', flexDirection: 'column', gap: 16 },
  featureItem: { display: 'flex', alignItems: 'center', gap: 14 },
  featureIcon: { width: 36, height: 36, background: 'rgba(255,255,255,0.15)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0 },
  featureText: { color: 'rgba(255,255,255,0.85)', fontSize: 15 },
  leftFooter: { color: 'rgba(255,255,255,0.4)', fontSize: 12, paddingTop: 24 },
  rightPanel: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' },
  formCard: { width: '100%', maxWidth: 440, background: '#fff', borderRadius: 20, padding: '44px 48px', boxShadow: '0 4px 24px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)' },
  formHeader: { marginBottom: 32 },
  logoForm: { height: 32, objectFit: 'contain', objectPosition: 'left', marginBottom: 28, display: 'block' },
  formTitle: { color: '#0f172a', fontSize: 24, fontWeight: 700, marginBottom: 6 },
  formSubtitle: { color: '#64748b', fontSize: 14 },
  errorBox: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, padding: '12px 16px', color: '#dc2626', fontSize: 14, marginBottom: 20, display: 'flex', gap: 8, alignItems: 'center' },
  form: { display: 'flex', flexDirection: 'column', gap: 20 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { color: '#374151', fontSize: 13, fontWeight: 600 },
  input: { border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '12px 16px', fontSize: 15, color: '#0f172a', outline: 'none', transition: 'border-color 0.2s', background: '#fff', width: '100%', boxSizing: 'border-box' },
  eyeBtn: { position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 },
  submitBtn: { background: 'linear-gradient(135deg, #1d4ed8, #2563eb)', color: '#fff', border: 'none', borderRadius: 10, padding: '14px', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 4, letterSpacing: '0.2px' },
  demoBox: { marginTop: 28, padding: '16px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12, display:'none' },
  demoTitle: { color: '#94a3b8', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: 10 },
  demoRow: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 ,display:'none' },
  demoRole: { background: '#dbeafe', color: '#1d4ed8', padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 700 },
  demoEmail: { color: '#475569', fontSize: 12, flex: 1 },
  demoPass: { color: '#94a3b8', fontSize: 12, fontFamily: 'monospace' },
};